var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "translation-settings",
      class: `translation-settings--${_vm.mode}`,
    },
    [
      _vm.showHeaderDescription
        ? _c("div", { staticClass: "translation-settings__subtitle" }, [
            _vm._v(
              "\n    Manage your translation glossary and excluded terms\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: "importFile",
        staticClass: "d-none",
        attrs: { type: "file", accept: ".xlsx,.xls,.csv" },
        on: { change: _vm.handleImportFileChanged },
      }),
      _vm._v(" "),
      _vm.importing
        ? _c(
            "div",
            { staticClass: "translation-settings__import-progress mb-3" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("b-progress", {
                attrs: {
                  animated: "",
                  value: "100",
                  variant: "primary",
                  height: "8px",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "translation-settings__tabs" }, [
        _c(
          "button",
          {
            staticClass: "translation-settings__tab",
            class: { "is-active": _vm.activeTab === "glossary" },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.activeTab = "glossary"
              },
            },
          },
          [
            _c("i", {
              staticClass: "bi bi-translate translation-settings__tab-icon",
            }),
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.mode === "page" ? "Translation Glossary" : "Glossary"
                ) +
                "\n    "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "translation-settings__tab",
            class: { "is-active": _vm.activeTab === "exclude" },
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.activeTab = "exclude"
              },
            },
          },
          [
            _c("i", {
              staticClass: "bi bi-shield-x translation-settings__tab-icon",
            }),
            _vm._v("\n      Exclude List\n    "),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.activeTab === "glossary"
        ? _c("div", [
            _c("div", { staticClass: "translation-settings__hint" }, [
              _vm._v(
                "\n      Define how specific terms should be translated for each language.\n      "
              ),
              _vm.mode === "page"
                ? _c("span", [
                    _vm._v(
                      "These overrides are applied automatically during image translation."
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "translation-settings__row" }, [
              _c("div", { staticClass: "translation-settings__search" }, [
                _c("i", {
                  staticClass: "bi bi-search translation-settings__search-icon",
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.glossarySearch,
                      expression: "glossarySearch",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control translation-settings__input",
                  attrs: { placeholder: "Search terms..." },
                  domProps: { value: _vm.glossarySearch },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.glossarySearch = $event.target.value.trim()
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "translation-settings__select-wrap" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.glossaryLanguageFilter,
                        expression: "glossaryLanguageFilter",
                      },
                    ],
                    staticClass: "form-control translation-settings__input",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.glossaryLanguageFilter = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.languageFilterOptions, function (opt) {
                    return _c(
                      "option",
                      { key: opt, domProps: { value: opt } },
                      [_vm._v("\n            " + _vm._s(opt) + "\n          ")]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _vm.mode === "page"
                ? _c(
                    "div",
                    { staticClass: "translation-settings__page-actions" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "translation-settings__action-btn",
                          attrs: { size: "sm", variant: "outline-secondary" },
                          on: { click: _vm.handleImportClick },
                        },
                        [
                          _c("i", { staticClass: "bi bi-upload mr-1" }),
                          _vm._v(" Import\n        "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "translation-settings__action-btn",
                          attrs: { size: "sm", variant: "outline-secondary" },
                          on: { click: _vm.handleExport },
                        },
                        [
                          _c("i", { staticClass: "bi bi-download mr-1" }),
                          _vm._v(" Export\n        "),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "translation-settings__add-box translation-settings__glossary-box",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "translation-settings__row translation-settings__row--add",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.glossaryDraft.source,
                          expression: "glossaryDraft.source",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control translation-settings__input",
                      attrs: { placeholder: "Source term" },
                      domProps: { value: _vm.glossaryDraft.source },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.glossaryDraft,
                            "source",
                            $event.target.value.trim()
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.glossaryDraft.language,
                            expression: "glossaryDraft.language",
                          },
                        ],
                        staticClass: "form-control translation-settings__input",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.glossaryDraft,
                              "language",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                        },
                      },
                      _vm._l(_vm.sortedLanguageOptions, function (opt) {
                        return _c(
                          "option",
                          { key: opt, domProps: { value: opt } },
                          [
                            _vm._v(
                              "\n            " + _vm._s(opt) + "\n          "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.glossaryDraft.translation,
                          expression: "glossaryDraft.translation",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control translation-settings__input",
                      attrs: { placeholder: "Translated term" },
                      domProps: { value: _vm.glossaryDraft.translation },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.glossaryDraft,
                            "translation",
                            $event.target.value.trim()
                          )
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn translation-settings__add-btn",
                        attrs: { type: "button" },
                        on: { click: _vm.addGlossaryEntry },
                      },
                      [
                        _c("i", { staticClass: "bi bi-plus-lg mr-1" }),
                        _vm._v(" Add\n        "),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "translation-settings__glossary-divider",
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "translation-settings__list translation-settings__list--glossary",
                  },
                  [
                    _vm._l(_vm.filteredGlossary, function (row) {
                      return _c(
                        "div",
                        {
                          key: row.id,
                          staticClass: "translation-settings__list-row",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "translation-settings__cell translation-settings__cell--source",
                            },
                            [
                              _vm.editingGlossaryId === row.id &&
                              _vm.editingGlossaryField === "source"
                                ? [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value:
                                            _vm.editingGlossaryDraft.source,
                                          expression:
                                            "editingGlossaryDraft.source",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      ref: "editSourceInput",
                                      refInFor: true,
                                      staticClass:
                                        "form-control translation-settings__input",
                                      domProps: {
                                        value: _vm.editingGlossaryDraft.source,
                                      },
                                      on: {
                                        keyup: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.stopPropagation()
                                            return _vm.saveGlossaryEdit.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "esc",
                                                27,
                                                $event.key,
                                                ["Esc", "Escape"]
                                              )
                                            )
                                              return null
                                            $event.stopPropagation()
                                            return _vm.cancelGlossaryEdit.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        ],
                                        blur: [
                                          _vm.saveGlossaryEdit,
                                          function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        ],
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.editingGlossaryDraft,
                                            "source",
                                            $event.target.value.trim()
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                : [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-link p-0 text-left w-100",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleGlossaryCellClick(
                                              row,
                                              "source"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(row.source) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "translation-settings__cell translation-settings__cell--lang",
                            },
                            [
                              _vm.editingGlossaryId === row.id &&
                              _vm.editingGlossaryField === "language"
                                ? [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.editingGlossaryDraft.language,
                                            expression:
                                              "editingGlossaryDraft.language",
                                          },
                                        ],
                                        ref: "editLanguageSelect",
                                        refInFor: true,
                                        staticClass:
                                          "form-control translation-settings__input",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                          keyup: [
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "enter",
                                                  13,
                                                  $event.key,
                                                  "Enter"
                                                )
                                              )
                                                return null
                                              $event.stopPropagation()
                                              return _vm.saveGlossaryEdit.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                            function ($event) {
                                              if (
                                                !$event.type.indexOf("key") &&
                                                _vm._k(
                                                  $event.keyCode,
                                                  "esc",
                                                  27,
                                                  $event.key,
                                                  ["Esc", "Escape"]
                                                )
                                              )
                                                return null
                                              $event.stopPropagation()
                                              return _vm.cancelGlossaryEdit.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          ],
                                          change: [
                                            function ($event) {
                                              var $$selectedVal =
                                                Array.prototype.filter
                                                  .call(
                                                    $event.target.options,
                                                    function (o) {
                                                      return o.selected
                                                    }
                                                  )
                                                  .map(function (o) {
                                                    var val =
                                                      "_value" in o
                                                        ? o._value
                                                        : o.value
                                                    return val
                                                  })
                                              _vm.$set(
                                                _vm.editingGlossaryDraft,
                                                "language",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            },
                                            _vm.saveGlossaryEdit,
                                          ],
                                        },
                                      },
                                      _vm._l(
                                        _vm.sortedLanguageOptions,
                                        function (opt) {
                                          return _c(
                                            "option",
                                            {
                                              key: opt,
                                              domProps: { value: opt },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(opt) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                : [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-link p-0 text-left w-100",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleGlossaryCellClick(
                                              row,
                                              "language"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(row.language) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "translation-settings__cell translation-settings__cell--trans",
                            },
                            [
                              _vm.editingGlossaryId === row.id &&
                              _vm.editingGlossaryField === "translation"
                                ? [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model.trim",
                                          value:
                                            _vm.editingGlossaryDraft
                                              .translation,
                                          expression:
                                            "editingGlossaryDraft.translation",
                                          modifiers: { trim: true },
                                        },
                                      ],
                                      ref: "editTranslationInput",
                                      refInFor: true,
                                      staticClass:
                                        "form-control translation-settings__input",
                                      domProps: {
                                        value:
                                          _vm.editingGlossaryDraft.translation,
                                      },
                                      on: {
                                        keyup: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            $event.stopPropagation()
                                            return _vm.saveGlossaryEdit.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "esc",
                                                27,
                                                $event.key,
                                                ["Esc", "Escape"]
                                              )
                                            )
                                              return null
                                            $event.stopPropagation()
                                            return _vm.cancelGlossaryEdit.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        ],
                                        blur: [
                                          _vm.saveGlossaryEdit,
                                          function ($event) {
                                            return _vm.$forceUpdate()
                                          },
                                        ],
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.editingGlossaryDraft,
                                            "translation",
                                            $event.target.value.trim()
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                : [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-link p-0 text-left w-100",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleGlossaryCellClick(
                                              row,
                                              "translation"
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(row.translation) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "translation-settings__trash",
                              attrs: { type: "button", title: "Delete" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.removeGlossaryEntry(row.id)
                                },
                              },
                            },
                            [_c("i", { staticClass: "bi bi-trash" })]
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filteredGlossary.length === 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "translation-settings__empty translation-settings__empty--glossary",
                          },
                          [
                            _vm._v(
                              "\n          No glossary entries yet.\n        "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "translation-settings__footer" }, [
              _vm._v("\n      " + _vm._s(_vm.glossaryCountText) + "\n    "),
            ]),
          ])
        : _c("div", [
            _c("div", { staticClass: "translation-settings__hint" }, [
              _vm._v(
                "\n      Terms that should never be translated (brand names, model numbers, etc.).\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "translation-settings__row translation-settings__row--exclude-search",
              },
              [
                _c(
                  "div",
                  { staticClass: "translation-settings__search w-100" },
                  [
                    _c("i", {
                      staticClass:
                        "bi bi-search translation-settings__search-icon",
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.excludeSearch,
                          expression: "excludeSearch",
                          modifiers: { trim: true },
                        },
                      ],
                      staticClass: "form-control translation-settings__input",
                      attrs: { placeholder: "Search terms..." },
                      domProps: { value: _vm.excludeSearch },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.excludeSearch = $event.target.value.trim()
                        },
                        blur: function ($event) {
                          return _vm.$forceUpdate()
                        },
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "translation-settings__row translation-settings__row--exclude",
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.trim",
                      value: _vm.excludeDraft,
                      expression: "excludeDraft",
                      modifiers: { trim: true },
                    },
                  ],
                  staticClass: "form-control translation-settings__input",
                  attrs: {
                    placeholder:
                      "Add term to exclude (e.g. brand name, model number)",
                  },
                  domProps: { value: _vm.excludeDraft },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.addExcludeTerm.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.excludeDraft = $event.target.value.trim()
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn translation-settings__add-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.addExcludeTerm },
                  },
                  [
                    _c("i", { staticClass: "bi bi-plus-lg mr-1" }),
                    _vm._v(" Add\n      "),
                  ]
                ),
                _vm._v(" "),
                _vm.mode === "page"
                  ? _c(
                      "b-button",
                      {
                        staticClass: "translation-settings__action-btn",
                        attrs: { size: "sm", variant: "outline-secondary" },
                        on: { click: _vm.handleImportClick },
                      },
                      [
                        _c("i", { staticClass: "bi bi-upload mr-1" }),
                        _vm._v(" Import\n      "),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.mode === "page"
                  ? _c(
                      "b-button",
                      {
                        staticClass: "translation-settings__action-btn",
                        attrs: { size: "sm", variant: "outline-secondary" },
                        on: { click: _vm.handleExport },
                      },
                      [
                        _c("i", { staticClass: "bi bi-download mr-1" }),
                        _vm._v(" Export\n      "),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "translation-settings__exclude-box" },
              [
                _vm._l(_vm.filteredExclude, function (term) {
                  return _c(
                    "div",
                    {
                      key: term,
                      staticClass: "translation-settings__exclude-row",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "translation-settings__exclude-term" },
                        [
                          _vm.editingExcludeTerm === term
                            ? [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model.trim",
                                      value: _vm.editingExcludeDraft,
                                      expression: "editingExcludeDraft",
                                      modifiers: { trim: true },
                                    },
                                  ],
                                  ref: "excludeEditInput",
                                  refInFor: true,
                                  staticClass:
                                    "form-control translation-settings__input translation-settings__exclude-input",
                                  domProps: { value: _vm.editingExcludeDraft },
                                  on: {
                                    keyup: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        $event.stopPropagation()
                                        return _vm.saveExcludeEdit.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "esc",
                                            27,
                                            $event.key,
                                            ["Esc", "Escape"]
                                          )
                                        )
                                          return null
                                        $event.stopPropagation()
                                        return _vm.cancelExcludeEdit.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    ],
                                    blur: [
                                      _vm.saveExcludeEdit,
                                      function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    ],
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.editingExcludeDraft =
                                        $event.target.value.trim()
                                    },
                                  },
                                }),
                              ]
                            : [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-link p-0 text-left w-100 translation-settings__exclude-labelbtn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.startExcludeEdit(term)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(term) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "translation-settings__exclude-trash",
                          attrs: { type: "button", title: "Delete" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.removeExcludeTerm(term)
                            },
                          },
                        },
                        [_c("i", { staticClass: "bi bi-trash" })]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.filteredExclude.length === 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "translation-settings__empty translation-settings__empty--exclude",
                      },
                      [_vm._v("\n        No excluded terms\n      ")]
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "translation-settings__footer" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.exclude.length) +
                  " term" +
                  _vm._s(_vm.exclude.length === 1 ? "" : "s") +
                  " will be kept in their original language during translation\n    "
              ),
            ]),
          ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-between mb-1" },
      [
        _c("small", { staticClass: "text-muted" }, [
          _vm._v("Importing translation settings..."),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }